import { CalendarTodayOutlined, MailOutlineOutlined, PhoneEnabledOutlined } from "@mui/icons-material";
import { Avatar, Card, CardActions, CardContent, IconButton, Stack, Typography } from "@mui/material";
import MobileView from "./MobileView";
import StandardView from "./StandardView";
import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { green } from "@mui/material/colors";

export default function AgentContactCard(props: { mobileView?: boolean }) {
	const { appState } = useContext(AppContext);
	const { info } = appState;
	function GetInitials(agentName: string) {
		var initials = "";
		if (agentName) {
			var tokens = agentName.split(" ");
			tokens.map((token) => (initials += token[0]));
		}
		return initials;
	}
	function isValidURL(str: string) {
		if (str === undefined || str === "" || str === null) return false;
		var validUrl = false;
		try {
			var _ = new URL(str);
			validUrl = true;
		} catch (_) {
			validUrl = false;
		}
		return validUrl;
	}

	var content = (
		<Card
			sx={{
				mb: 0,
				background: `linear-gradient(-60deg ,${appState.colorPallete["scheme2"]}, #ffffff)`,
			}}
		>
			<CardContent>
				<Stack sx={{ alignItems: "center" }}>
					<Avatar
						sx={{
							// boxShadow: "5px 5px 10px 2px rgba(0,0,0,.8)",
							width: 72,
							height: 72,
						}}
						src={info.agent.agent_photo ?? ""}
					>
						{GetInitials(info.agent.agentName)}
					</Avatar>
					<Typography variant="h5" sx={{ fontWeight: 500, fontsize: "24px", lineHeight: "32px" }} pt={1}>
						{info.agent.agentName}
					</Typography>
					<Typography variant="caption">{info.agent?.businessTitle}</Typography>
					<Typography component={"p"} sx={{ fontWeight: 400, fontsize: "16px", lineHeight: "24px" }}>
						{info.agent?.businessName}
					</Typography>
				</Stack>
			</CardContent>

			<CardActions sx={{ justifyContent: "center", pb: 2 }}>
				{isValidURL(info?.agent?.scheduleLink) && (
					<IconButton
						sx={{
							height: 40,
							width: 198,
							color: "white",
							background: appState.colorPallete["scheme1"],
							borderRadius: "8px",
							// padding: "0px 4px 0px 4px",
						}}
						onClick={() => {
							var link = info?.agent.scheduleLink;
							window.open(link, "width=600,height=600");
						}}
					>
						<CalendarTodayOutlined sx={{ height: 20, width: 20 }} />
						<Typography sx={{ pl: 1 }} variant="caption" textTransform={"capitalize"}>
							Schedule a meeting
						</Typography>
					</IconButton>
				)}
				{info?.agent?.email && (
					<IconButton
						color="secondary"
						className="agent-contact-button"
						sx={{
							color: "black",
							borderColor: "black",
							borderRadius: "8px",
							height: 40,
							width: 40,
							border: "0.5px solid grey",
						}}
						onClick={() => {
							window.open(`mailto:${info?.agent?.email}`, "_self");
						}}
					>
						<MailOutlineOutlined sx={{ height: 20, width: 20 }} />
					</IconButton>
				)}
				{info?.agent?.agent_phone_no && (
					<IconButton
						className="agent-contact-button"
						sx={{
							color: "black",
							borderColor: "black",
							borderRadius: "8px",
							height: 40,
							width: 40,
							border: "0.5px solid grey",
						}}
						onClick={() => {
							window.open(`tel:${info?.agent?.agent_phone_no}`);
						}}
					>
						<PhoneEnabledOutlined sx={{ height: 20, width: 20 }} />
					</IconButton>
				)}
			</CardActions>
		</Card>
	);
	if (props.mobileView) {
		return <MobileView>{content}</MobileView>;
	}
	return <StandardView> {content}</StandardView>;
}
